import { QueryClient } from '@tanstack/react-query';

import { ApiResponseError } from '../api/envelope';

// Defaults per architectureDesign.md §4.3. Retries skip 4xx envelope failures
// (validation, not found, unauthorized, conflict) — those are deterministic and
// re-running them just multiplies the toast spam. 5xx and network errors stay
// retried twice.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          if (error instanceof ApiResponseError) {
            const status = error.status ?? 0;
            if (status >= 400 && status < 500) return false;
          }
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
